import * as React from 'react';
import {useSidebarState} from 'react-admin';
import {styled} from '@mui/material/styles';

const Footer = styled('div', {shouldForwardProp: prop => prop !== 'sidebarOpen'})<{sidebarOpen: boolean}>(
  ({sidebarOpen}) => ({
    width: sidebarOpen ? '240px' : '55px',
    backgroundColor: '#505050',
    transition: sidebarOpen ? 'width 0' : 'width 0.4s',
    height: '141px',
  }),
);

const FooterContainer = styled('div', {shouldForwardProp: prop => prop !== 'sidebarOpen'})<{sidebarOpen: boolean}>(
  ({sidebarOpen}) => ({
    padding: sidebarOpen ? '2rem' : '0 0 2rem',
    height: sidebarOpen ? undefined : '92px',
  }),
);

const FooterLogo = styled('div', {shouldForwardProp: prop => prop !== 'sidebarOpen'})<{sidebarOpen: boolean}>(
  ({sidebarOpen}) => ({
    marginBottom: sidebarOpen ? '0.75rem' : 0,
    transition: 'transform 0.5s',
    width: sidebarOpen ? undefined : '55px',
    '& svg': sidebarOpen ? undefined : {transform: 'rotate(-90deg) translate(-50%, -70%)'},
  }),
);

const FooterBody = styled('div')({
  fontSize: '12px',
  color: '#ccc',
  '& a': {
    color: '#3cc',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

export const MenuFooter = () => {
  const [open] = useSidebarState();

  return (
    <Footer sidebarOpen={open}>
      <FooterContainer sidebarOpen={open}>
        <FooterLogo sidebarOpen={open}>
          <svg width="92" height="32" viewBox="0 0 138 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
              <path
                d="M80.5796 14.6071C80.5796 15.7335 79.6668 16.6419 78.535 16.6419C77.4031 16.6419 76.4904 15.7335 76.4904 14.6071C76.4904 13.4807 77.4031 12.5723 78.535 12.5723C79.6303 12.5723 80.5796 13.4807 80.5796 14.6071Z"
                fill="#ffffff"
              />
              <path
                d="M78.1332 19.2946C77.184 19.2219 76.3077 19.8033 76.0521 21.3294L73.5694 40.2242C73.4233 41.9683 74.5917 43.0584 75.9061 43.2037C77.184 43.3491 78.6079 42.4043 78.7174 40.7329L79.8127 21.6928C79.9223 20.1666 79.0825 19.3673 78.1332 19.2946Z"
                fill="#ffffff"
              />
              <path
                d="M38.9207 24.8176C38.1904 25.7624 34.7949 28.8509 34.7949 28.8509C37.5698 20.857 39.6509 23.8729 38.9207 24.8176ZM6.02435 39.0977C6.79108 34.9554 8.25152 31.7942 10.6247 28.8873C11.2454 28.1969 12.7789 26.6708 14.6044 27.1795C14.0933 29.7594 9.82148 35.8275 6.02435 39.0977ZM73.5695 17.8411C73.0218 17.5141 72.3646 17.7684 71.9995 17.9865C70.7216 18.6768 65.7196 25.2537 60.9367 31.9032L57.0666 21.0023C56.4094 19.2946 54.7299 18.8949 53.598 20.53C53.598 20.53 46.0403 31.2491 43.2655 34.4467C40.6732 37.4989 38.519 37.5716 37.2046 36.8086C36.1458 36.1908 35.3791 34.7737 35.3426 33.2113L40.9653 28.3059C41.0018 28.2696 41.0383 28.2332 41.0748 28.1969L41.1843 28.0879C41.805 27.5429 42.3162 27.0705 42.5352 26.8161C43.8496 25.399 43.9957 23.7639 43.5575 22.3831C43.0099 20.639 40.9653 19.4762 39.1397 19.6216C38.2269 19.6942 37.3872 19.9123 36.3284 20.53C31.2899 23.6549 30.7057 31.3218 30.7057 31.3218C28.4055 33.9017 24.3528 37.935 22.3812 38.9524C21.9431 39.1704 21.3589 39.3157 20.8843 39.1341C18.4015 38.0076 19.935 29.396 20.8113 25.399C21.4685 22.3468 27.0181 3.77903 27.0181 3.77903C27.7118 1.30818 26.5435 0.327104 25.1195 0.0364154C23.7321 -0.254274 22.7463 0.436112 21.8336 2.21658C21.0303 3.81537 20.5557 5.52317 20.081 7.23096C18.6206 12.5724 15.8093 23.5095 15.8093 23.5095C15.8093 23.5095 14.86 22.4558 13.5821 22.0198C10.5882 21.0023 8.43407 22.4195 6.35295 24.636C5.58622 25.4354 4.92903 26.3438 4.34485 27.2885C3.1765 29.1053 0.0365679 35.7548 -0.0364538 41.1326C-0.0729647 43.0584 0.219122 44.8025 2.11769 45.6382C3.03046 46.0379 4.34485 45.9289 4.70996 45.8199C7.37526 45.2022 10.9168 42.7677 15.5172 33.1023C15.5537 34.047 15.4807 35.3188 15.5172 35.9365C15.6997 37.935 15.8458 39.9335 16.9046 41.7139C18.1825 43.8578 20.3731 44.6208 22.6368 43.6397C23.9147 43.0947 25.9593 41.4232 27.7118 39.7881L31.3629 36.6269C31.6915 38.3347 32.0931 39.5338 32.7868 40.6965C34.6124 43.7124 37.7158 44.5845 40.8922 43.0947C41.878 42.6223 42.8273 41.9683 43.6671 41.2779C44.9084 40.1878 46.1133 38.698 47.2451 37.3173C48.9977 35.1371 53.8536 27.1432 53.8536 27.1432C54.1092 28.1242 56.811 40.0425 57.2491 41.0599C58.2349 43.3491 61.3383 43.4581 62.7623 41.4596C63.9306 39.8245 72.6932 22.5285 73.8616 19.5489C74.1902 18.7495 74.0076 18.0955 73.5695 17.8411Z"
                fill="#ffffff"
              />
              <path
                d="M118.259 22.6736C119.756 21.9833 120.741 22.9643 120.23 23.5094C119.427 24.3814 115.192 27.3973 115.192 27.3973C115.447 24.8538 117.455 23.0733 118.259 22.6736ZM137.5 19.5124C136.441 19.04 135.127 20.8568 134.36 21.8016C132.133 24.4178 129.979 27.143 127.642 29.6502C126.036 31.358 124.283 32.9568 122.384 34.3375C120.924 35.3913 119.208 36.1907 117.675 35.1006C116.287 34.1558 115.886 32.8114 115.63 30.8493L121.18 26.6706C121.216 26.6343 121.253 26.5979 121.326 26.5616L121.435 26.4889C122.092 25.9802 122.64 25.5805 122.896 25.3262C124.32 24.0181 124.539 22.3829 124.21 21.0022C123.772 19.2217 121.837 17.9136 120.011 17.9499C119.098 17.9499 118.222 18.0953 117.163 18.6767C111.906 21.4382 111.322 29.1051 111.322 29.1051C105.042 33.3201 99.7842 36.772 97.338 38.2255C97.338 38.2255 103.362 23.6547 103.983 22.0196C104.494 20.6752 105.005 19.2944 105.334 17.8773C105.882 15.7334 104.713 14.4617 102.523 14.6797C102.084 14.716 101.683 14.7887 101.245 14.934C95.4394 16.4965 89.8532 18.7493 84.2306 20.7842C82.259 21.5109 81.5288 22.6373 81.9304 23.4367C82.478 24.5631 84.3036 24.2361 85.1433 24.0544L98.6889 20.3118C98.6889 20.3118 89.3421 42.1498 88.6484 45.5291C88.2833 47.3095 90.0723 48.5813 91.7518 47.8546C92.555 47.4912 93.2853 46.9825 93.979 46.4738L111.358 33.2474C111.723 35.0279 112.234 36.3724 112.636 37.2081C114.389 40.8054 118.222 41.9318 121.837 40.4783C125.634 38.9522 133.301 28.8508 137.317 21.6926C137.792 20.8205 138.084 19.8031 137.5 19.5124Z"
                fill="#ffffff"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="137.829" height="48" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </FooterLogo>
        {open && <FooterBody>
          {' '}
          <div>Devize Admin Demo v2.0</div>
          <div>
            Developed by <a href="https://devize.se">Devize</a> © 2021
          </div>
        </FooterBody>}
      </FooterContainer>
    </Footer>
  );
};

export default MenuFooter;
